import Icon from './Icon';
import { STRIP_ITEMS } from '../constants/content';

export default function FeatureStrip() {
  return (
    <section className="strip">
      <div className="shell strip__grid">
        {STRIP_ITEMS.map((item) => (
          <article className="strip__card" key={item.title}>
            <span className="strip__icon">
              <Icon name={item.icon} size={20} />
            </span>
            <h3>{item.title}</h3>
            <p>{item.text}</p>
          </article>
        ))}
      </div>
    </section>
  );
}
